import React, { useState } from "react";

interface TruncatedTextProps {
    text: string;
    limit?: number;
}

const TruncatedText: React.FC<TruncatedTextProps> = ({ text, limit = 30 }) => {
    const [expanded, setExpanded] = useState(false);

    const isTooLong = text.length > limit;
    const displayText = expanded || !isTooLong ? text : text.slice(0, limit) + "...";

    return (
        <div style={{ whiteSpace: "pre-wrap" }}>
            <span>{displayText}</span>
            {isTooLong && (
                <button
                    onClick={() => setExpanded(!expanded)}
                    style={{
                        marginLeft: "8px",
                        color: "#007bff",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: 0,
                        fontSize: "0.9rem",
                    }}
                >
                    {expanded ? "접기" : "더보기"}
                </button>
            )}
        </div>
    );
};

export default TruncatedText;